page starts-->
    <section class="page-wrapper">
       <div class="mybooking-section cf">
       	  <div class="container">
       	  	  <div class="mybooking-detail">
       	  	  	  <div class="red-titel">My Bookings</div>
       	  	  	  <div class="mybooking-tab-section cf">
       	  	  	  	 <div class="mybooking-tab">
       	  	  	  	 	<ul>
       	  	  	  	 		<li><a href="javascript:void(0);" class="courses-name active" id="past-booking">Past Bookings</a></li>
       	  	  	  	 		<li><a href="javascript:void(0);" class="courses-name" id="upcoming-booking">Upcoming Bookings</a></li>
       	  	  	  	 	</ul>
       	  	  	  	 </div>
       	  	  	  	 <div class="mybooking-tab-detail-section course-main-content active cf" id="past-booking-content">
                       <div class="mybooking-tab-detail">
                          <div class="mybooking-tab-detail-left">
                            <div class="mybooking-tab-detail-top cf" *ngFor="let userticket of userticketList?.data?.past_booking">
                               <div class="mybooking-tab-detail-top-left">
                                  <div class="mybooking-tab-detail-top-logo-left">
                                     <img [src]="userticket?.first_team_image">
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-center">
                                    <div class="mybooking-tab-detail-top-logo-center-inner">
                                      <h3>vs</h3>
                                    </div>
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-right">
                                    <img [src]="userticket?.second_team_image">
                                  </div>
                               </div>
                               <div class="mybooking-tab-detail-top-right">
                                 <div class="mybooking-tab-detail-top-right-content">
                                   <p>{{userticket?.title}}</p>
                                   <h3>{{userticket?.date_time | amDateFormat:'dddd, DD MMMM  YYYY HH:mm'}}</h3>
                                 </div>
                                 <div class="mybooking-tab-detail-top-right-dot">
                                    <a href="javascript:void(0);"></a>
                                 </div>
                               </div>
                            </div>
                            <!-- <div class="mybooking-tab-detail-bottom cf">
                               <div class="mybooking-tab-detail-top-left">
                                  <div class="mybooking-tab-detail-top-logo-left">
                                     <img src="assets/images/Bitmap.png">
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-center">
                                    <div class="mybooking-tab-detail-top-logo-center-inner">
                                      <h3>vs</h3>
                                    </div>
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-right">
                                    <img src="assets/images/Bitmap-two.png" >
                                  </div>
                               </div>
                               <div class="mybooking-tab-detail-top-right">
                                 <div class="mybooking-tab-detail-top-right-content">
                                   <p>Ashton United V South Shields</p>
                                   <h3>Saturday, 3 November 2020 15:00</h3>
                                 </div>
                               </div>
                            </div> -->
                          </div>
                          <div class="mybooking-tab-detail-right cf">
                            <div class="mybooking-tab-detail-right-inner cf">
                              <h2>Bookings Summary</h2>
                              <div class="mybooking-tab-detail-right-top">
                                <h3>General Admission </h3>
                                <div class="mybooking-tab-detail-right-top-detail cf" *ngFor="let assgeneral of userticketList?.data?.past_booking[0]?.match_ticket_assign_general">
                                    <div class="mybooking-tab-detail-right-top-detail-left" >
                                       <p>{{assgeneral?.type}}</p>
                                    </div>
                                    <div class="mybooking-tab-detail-right-top-detail-right">
                                       <p>£{{assgeneral?.amount}}.00</p>
                                    </div>
                                </div>
                                <!-- <div class="mybooking-tab-detail-right-top-detail cf">
                                    <div class="mybooking-tab-detail-right-top-detail-left">
                                       <p>Student</p>
                                    </div>
                                    <div class="mybooking-tab-detail-right-top-detail-right">
                                       <p>2 Nos.</p>
                                    </div>
                                </div> -->
                                <h3>Away Fans</h3>
                                <div class="mybooking-tab-detail-right-top-detail cf" *ngFor="let assaway of userticketList?.data?.past_booking[0]?.match_ticket_assign_away">
                                    <div class="mybooking-tab-detail-right-top-detail-left" >
                                       <p>{{assaway?.type}}</p>
                                    </div>
                                    <div class="mybooking-tab-detail-right-top-detail-right">
                                       <p>£{{assaway?.amount}}.00</p>
                                    </div>
                                </div>
                                <!-- <div class="mybooking-tab-detail-right-top-detail cf">
                                    <div class="mybooking-tab-detail-right-top-detail-left">
                                       <p>Assigned to: John Smith <a href="#">johnsmith@gmail.com</a> | ASH0000843</p>
                                    </div>
                                    <div class="mybooking-tab-detail-right-top-detail-right">
                                       <p>2 Nos.</p>
                                    </div>
                                </div> -->
                              </div>
                              <div class="mybooking-tab-detail-right-center">
                                  <div class="mybooking-tab-detail-right-center-left">
                                     <a href="#"><img src="assets/images/verified.svg"></a>
                                  </div>
                                  <div class="mybooking-tab-detail-right-center-right">
                                      <h3>Paid £{{userticketList?.data?.past_booking[0]?.booking_detail?.total}}.00</h3>
                                      <p>{{userticketList?.data?.past_booking[0]?.booking_detail?.payment_date | amDateFormat:'dddd, DD MMMM  YYYY'}}</p>
                                  </div>
                              </div>
                              <div class="mybooking-tab-detail-right-bottom">
                                  <h3>Booking Details</h3>
                                  <div class="mybooking-tab-detail-right-bottom-detail cf">
                                      <div class="mybooking-tab-detail-right-bottom-left">
                                         <p>Items</p>
                                      </div>
                                      <div class="mybooking-tab-detail-right-bottom-right">
                                          <p>{{userticketList?.data?.past_booking[0]?.booking_detail?.item}} Nos.</p>
                                      </div>
                                  </div>
                                  <div class="mybooking-tab-detail-right-bottom-detail cf">
                                      <div class="mybooking-tab-detail-right-bottom-left">
                                         <p>Per item fees</p>
                                      </div>
                                      <div class="mybooking-tab-detail-right-bottom-right">
                                          <p>£10.00</p>
                                      </div>
                                  </div>
                                  <div class="mybooking-tab-detail-right-bottom-detail cf">
                                      <div class="mybooking-tab-detail-right-bottom-left">
                                         <p>Order Fees</p>
                                      </div>
                                      <div class="mybooking-tab-detail-right-bottom-right">
                                          <p>£10.00</p>
                                      </div>
                                  </div>
                                  <div class="mybooking-tab-detail-right-bottom-detail cf">
                                      <div class="mybooking-tab-detail-right-bottom-left">
                                         <p>Order Discount</p>
                                      </div>
                                      <div class="mybooking-tab-detail-right-bottom-right">
                                          <p>£10.00</p>
                                      </div>
                                  </div>
                                  <div class="mybooking-tab-detail-right-bottom-detail total cf">
                                      <div class="mybooking-tab-detail-right-bottom-left">
                                         <p>Total Amount</p>
                                      </div>
                                      <div class="mybooking-tab-detail-right-bottom-right">
                                          <p>£{{userticketList?.data?.past_booking[0]?.booking_detail?.total}}.00</p>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                       </div>   
                     </div>
                     <div class="mybooking-tab-detail-section course-main-content cf" id="upcoming-booking-content">
                       <div class="mybooking-tab-detail">
                          <div class="mybooking-tab-detail-left">
                            <div class="mybooking-tab-detail-top cf" *ngFor="let userticket of userticketList?.data?.upcoming_booking">
                               <div class="mybooking-tab-detail-top-left">
                                  <div class="mybooking-tab-detail-top-logo-left">
                                     <img [src]="userticket?.first_team_image">
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-center">
                                    <div class="mybooking-tab-detail-top-logo-center-inner">
                                      <h3>vs</h3>
                                    </div>
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-right">
                                    <img [src]="userticket?.second_team_image" >
                                  </div>
                               </div>
                               <div class="mybooking-tab-detail-top-right">
                                 <div class="mybooking-tab-detail-top-right-content">
                                   <p>{{userticket?.title}}</p>
                                   <h3>{{userticket?.date_time | amDateFormat:'dddd, DD MMMM  YYYY HH:mm'}}</h3>
                                 </div>
                                 <div class="mybooking-tab-detail-top-right-dot">
                                    <a href="javascript:void(0);"></a>
                                 </div>
                               </div>
                            </div>
                            <!-- <div class="mybooking-tab-detail-bottom cf">
                               <div class="mybooking-tab-detail-top-left">
                                  <div class="mybooking-tab-detail-top-logo-left">
                                     <img src="assets/images/Bitmap.png">
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-center">
                                    <div class="mybooking-tab-detail-top-logo-center-inner">
                                      <h3>vs</h3>
                                    </div>
                                  </div>
                                  <div class="mybooking-tab-detail-top-logo-right">
                                    <img src="assets/images/Bitmap-two.png" >
                                  </div>
                               </div>
                               <div class="mybooking-tab-detail-top-right">
                                 <div class="mybooking-tab-detail-top-right-content">
                                   <p>Ashton United V South Shields</p>
                                   <h3>Saturday, 3 November 2020 15:00</h3>
                                 </div>
                               </div>
                            </div> -->
                          </div>
                          <div class="mybooking-tab-detail-right cf">
                            <div class="mybooking-tab-detail-right-inner cf">
                              <div class="mybooking-tab-detail-right-top">
                                 <div class="mybooking-tab-detail-scanner">
                                    <div class="mybooking-tab-detail-scanner-top">
                                      <a href="javascript:void(0);">scan at staduim</a>
                                    </div>
                                    <div class="mybooking-tab-detail-scanner-image">
                                       <img src="assets/images/qr-code.svg">
                                    </div>
                                    <div class="mybooking-tab-detail-scanner-bottom">
                                       <h3>John Smith</h3>
                                       <p><a href="#">johnsmith@gmail.com</a></p>
                                    </div>
                                 </div>
                                 <div class="mybooking-tab-detail-right-arrow">
                                    <a href="javascript:void(0);"><img src="assets/images/next-ic.svg"></a>
                                 </div>
                              </div>
                              <div class="mybooking-tab-detail-right-center">
                                  <div class="mybooking-tab-detail-right-center-left">
                                     <a href="javascript:void(0);"><img src="assets/images/verified.svg"></a>
                                  </div>
                                  <div class="mybooking-tab-detail-right-center-right">
                                      <h3>Paid £{{userticketList?.data?.upcoming_booking[0]?.booking_detail?.total}}.00</h3>
                                      <p>{{userticketList?.data?.upcoming_booking[0]?.booking_detail?.payment_date | amDateFormat:'dddd, DD MMMM  YYYY'}}</p>
                                  </div>
                              </div>
                              <div class="mybooking-tab-detail-right-bottom">
                                  <div class="mybooking-tab-btn">
                                     <a href="javascript:void(0);">Cancel Booking</a>
                                  </div>
                              </div>
                            </div>
                            <div class="mybooking-tab-cancellation cf">
                                <h3>Cancellation Reason</h3>
                                <div class="mybooking-tab-cancellation-detail">
                                    <textarea  name="comment" form="usrform">Enter text here...</textarea>
                                </div>
                                <div class="mybooking-tab-submit">
                                   <a href="javascript:void(0);">Submit</a>
                                </div>
                            </div>
                          </div>
                       </div>   
                     </div>
       	  	  	  </div>
       	  	  </div>
       	  </div>
       </div>
    </section>